import React from 'react';
import Chip from '@material-ui/core/Chip';

// Clickable chip that reads as filled-primary when selected and as an outline when not.
// Shared by every chip-row selector so their selected states can't drift apart.
export const SelectableChip: React.FC<{
  label: React.ReactNode;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}> = ({ label, selected, onClick, disabled }) => (
  <Chip
    label={label}
    clickable
    color={selected ? 'primary' : 'default'}
    variant={selected ? 'default' : 'outlined'}
    onClick={onClick}
    disabled={disabled}
  />
);
